// extracted by mini-css-extract-plugin
module.exports = {"newsItem":"News_newsItem__1fZD_","title":"News_title__2Ztq1","wrapper":"News_wrapper__1ntlY","paragraph":"News_paragraph__3ywMs","date":"News_date__1ko3w"};